import "./index.css";

export const EntregasDevolucionesPreimpresos = () => {
  return (
    <div className="container">
      <div className="indicator">
        <h1>Matriz de control Entregas-Devoluciones Preimpresos</h1>
      </div>
    </div>
  );
};
